export enum GradebookStatus {
    Passed = 0,
    Failed = 1,
    NotResulted = 2
}